export default "__VITE_ASSET__Dwsd5UY9__"